import { useEffect, useState } from 'react'

import useFetchWrapper, { HttpResponse } from '../../../Helpers/useFetchWrapper';

import { Article, HookProps, TabStatus } from './ArticlesTab.model';

const useArticlesTab = ({ id }: HookProps) => {
  const [ articles, setArticles ] = useState<Article[]>([]);
  const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);

  const { get } = useFetchWrapper();

  useEffect(() => {
    getArticles();
  }, [id]);

  const getArticles = async () => {
    const response: HttpResponse<Article[]> = await get(`/user/profile/article/${id}`);

    const articles: Article[] = response.parsedBody?.map((article: Article) => ({
      articleId: article.articleId,
      authors: article.authors, 
      description: article.description,
      link: article.link,
      publishedIn: article.publishedIn,
      publishingLocation: article.publishingLocation,
      publishingYear: article.publishingYear,
      tags: article.tags,
      title: article.title
    })) || [];

    setArticles(articles);

		setTabStatus(TabStatus.Loaded);
  }

  return {
    state: {
      articles,
      tabStatus,
    },
  }

}
export default useArticlesTab;